<template>
  <div class="flex flex-wrap -mb-8 -mr-6 p-8">
    <div v-if="isNew" class="pr-6 pb-8 w-full lg:w-2/2">
      <select-dropdown
        required
        v-model="form.treatment_type_id" :options="treatment_types"
        :error="form.errors.treatment_type_id" :label="$t('treatments.treatment_type_id')"
      />
    </div>
    <select-dropdown
      v-if="isTypeBenevole && isNew"
      v-model="form.volunteer_id" :options="volunteers" :error="form.errors.volunteer_id"
      class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('interventions.volunteer')"
      :required="isBenevoleRequired"
    />
    <text-input
      v-if="isTypeBenevole && !isNew"
      v-model="form.volunteer_name"
      readonly
      class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('interventions.volunteer')"
    />
    <text-input
      required
      v-model="form.date_open"
      :date-not-in-future="true" type="date" :error="form.errors.date_open" class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('treatments.date_open')"
    />
    <select-dropdown
      v-if="!isNew" v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/4"
      :options="statuses" :label="$t('applications.status')"
    />
    <text-input
      v-if="currentStatus === 3"
      v-model="form.date_closed" :date-not-in-future="true" :type="'date'"
      :error="form.errors.date_closed"
      :required="requiredDate"
      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('treatments.date_closed')"
    />
    <textarea-input
      v-if="currentStatus === 3"
      v-model="form.reason_closed" :error="form.errors.reason_closed"
      class="pb-8 pr-6 w-full lg:w-2/2" :label="$t('treatments.reason_closed')" rows="4"
    />
  </div>
</template>
<script>
import selectDropdown from '@/Shared/SelectDropdown'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'

export default {
  components: {selectDropdown, TextareaInput, TextInput},
  props: ['formData', 'treatment_types', 'statuses', 'isNew', 'volunteers'],
  data() {
    return {
      requiredDate: false,
    }
  },
  computed: {
    form() {
      return this.formData
    },
    currentStatus() {
      return this.form.status
    },
    isTypeBenevole(){
      return (this.form.treatment_type_id === 6)
    },
    isBenevoleRequired() {
      return (this.isTypeBenevole && this.isNew)
    }
  },
  watch: {
    currentStatus() {
      this.setCorrectFields()
    },
    emptyLocationField(){
      if (this.emptyLocationField) {
        this.requiredName = true
      } else {
        this.requiredName = false
      }
    },
  },
  mounted() {
    this.setCorrectFields()
  },
  methods: {
    setCorrectFields() {
      if (this.form.status === 3) {
        this.requiredDate = true
      } else {
        this.requiredDate = false
      }

    },
  },
}
</script>
